import { __assign } from 'tslib';
import { isString } from '../utils.js';

var createUnitType = function (unit) { return ({
    test: function (v) {
        return isString(v) && v.endsWith(unit) && v.split(' ').length === 1;
    },
    parse: parseFloat,
    transform: function (v) { return "" + v + unit; },
}); };
var degrees = createUnitType('deg');
var percent = createUnitType('%');
var px = createUnitType('px');
var vh = createUnitType('vh');
var vw = createUnitType('vw');
var progressPercentage = __assign(__assign({}, percent), { parse: function (v) { return percent.parse(v) / 100; }, transform: function (v) { return percent.transform(v * 100); } });

export { degrees, percent, progressPercentage, px, vh, vw };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/node_modules/style-value-types/dist/es/numbers/units.js
// module id = 80
// module chunks = 0